import { StyleSheet } from '@react-pdf/renderer';

export const stylesMovimentacaoReport = StyleSheet.create(
  {
    page: {
      paddingTop: 40,
      paddingBottom: 40,
      paddingHorizontal: 30,
      fontSize: 10,
      fontFamily: 'Helvetica',
      position: 'relative',
    },
    title: {
      fontSize: 14,
      textAlign: 'center',
      marginBottom: 10,
    },
    subtitle: {
      marginBottom: 10,
    },
    section: {
      marginBottom: 10,
    },
    header: {
      fontSize: 12,
      marginBottom: 10,
      fontWeight: 'bold',
    },
    table: {
      display: 'flex',
      width: 'auto',
      borderStyle: 'solid',
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    tableRow: {
      flexDirection: 'row',
    },

    tableColCTipo: {
      width: '50%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      backgroundColor: '#f0f0f0',
      padding: 3,
      fontWeight: 'bold',
    },
    tableColCProcessos: {
      width: '40%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      backgroundColor: '#f0f0f0',
      padding: 3,
      fontWeight: 'bold',
    },
    tableColCQuantidade: {
      width: '10%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      backgroundColor: '#f0f0f0',
      padding: 3,
      fontWeight: 'bold',
    },

    tableColRTipo: {
      width: '50%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      padding: 3,
    },
    tableColRProcessos: {
      width: '40%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      padding: 3,
      flexDirection: 'row',
    },
    tableColRQuantidade: {
      width: '10%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      padding: 3,
      textAlign: 'right',
    },

    tableColRes1: {
      width: '80%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      backgroundColor: '#f0f0f0',
      padding: 3,
      fontWeight: 'bold',
    },
    tableColRes2: {
      width: '20%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      backgroundColor: '#f0f0f0',
      padding: 3,
      fontWeight: 'bold',
    },
    tableColRes3: {
      width: '80%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      padding: 3,
    },
    tableColRes4: {
      width: '20%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      padding: 3,
      textAlign: 'right',
    },
  });